import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { CategoryObjectType } from '../pages/admin_metadata_categories/types';
import type { SelectedMetadataViewId } from './types';
import { getSelectedMetadataViewKey } from './utils';

export type MetadataBulkSelectViewPayload = {
  categoryName: string;
  viewId: string | undefined;
};

export type MetadataEntitySelectViewPayload = {
  categoryObjectType: CategoryObjectType;
  categoryName: string;
  viewId: string | undefined;
};

const initialState: SelectedMetadataViewId = {
  bulk: {},
  entities: {},
};

export const selectedMetadataSlice = createSlice({
  name: 'selected_metadata',
  initialState,
  reducers: {
    metadataBulkSelectView: (
      state,
      action: PayloadAction<MetadataBulkSelectViewPayload>,
    ) => {
      state.bulk = { [action.payload.categoryName]: action.payload.viewId };
    },
    metadataEntitySelectView: (
      state,
      action: PayloadAction<MetadataEntitySelectViewPayload>,
    ) => {
      state.entities[
        getSelectedMetadataViewKey(
          action.payload.categoryObjectType,
          action.payload.categoryName,
        )
      ] = action.payload.viewId;
    },
  },
});

export const { metadataBulkSelectView, metadataEntitySelectView } =
  selectedMetadataSlice.actions;

export const selectedMetadataReducer = selectedMetadataSlice.reducer;
